var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoicemailNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "voicemail_new") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "voicemail"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.46,13.62a6,6,0,0,0-5.91,5.91,6,6,0,0,0,1.39,3.77H13a6,6,0,0,0,1.4-3.77,6,6,0,0,0-5.92-5.91,5.92,5.92,0,0,0,0,11.83h14a5.92,5.92,0,1,0,0-11.83Zm-14,9.68a3.77,3.77,0,0,1,0-7.53,3.77,3.77,0,1,1,0,7.53Zm14,0a3.77,3.77,0,1,1,3.76-3.77A3.81,3.81,0,0,1,22.46,23.3Z",
    style: {
      fill: "gray"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "25.53 8.18 26.68 10.4 30.44 8.27 28.3 12.03 30.53 13.18 28.3 14.32 30.44 18.09 26.68 15.95 25.53 18.18 24.38 15.95 20.62 18.09 22.76 14.32 20.53 13.18 22.76 12.03 20.62 8.27 24.38 10.4 25.53 8.18",
    style: {
      fill: "#e9c181"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.53,
    y: 12.18,
    width: 2,
    height: 2,
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoicemailNew);
export default __webpack_public_path__ + "static/media/voicemail_new.d56d01d0.svg";
export { ForwardRef as ReactComponent };